import { Card, FormField, FormFieldRow, Heading, ReadOnlyField } from '@msaf/core-react'
import { ScreenFieldsView } from '../../../../types/form-types'

interface WellConstructionScreensViewInterface {
  fields: Partial<ScreenFieldsView>
  index: number
  isLoading: boolean
}

export default function WellConstructionScreensView({
  fields,
  index,
  isLoading,
}: WellConstructionScreensViewInterface) {
  return (
    <Card>
      <Heading isSkeleton={isLoading} level={4}>
        {`Screen ${index + 1}`}
      </Heading>
      <FormField isSkeleton={isLoading} label='Type' labelId='screenTypeLabel'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='screenTypeLabel' value={`${fields['screenType'] ?? ''}`} />
      </FormField>
      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Top(m)' labelId='screenTopLabel'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='screenTopLabel' value={`${fields['screenTop'] ?? ''}`} />
        </FormField>
        <FormField isSkeleton={isLoading} label='Bottom(m)' labelId='screenBottomLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='screenBottomLabel'
            value={`${fields['screenBottom'] ?? ''}`}
          />
        </FormField>
      </FormFieldRow>

      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Screen leader top(m)' labelId='screenLeaderTopLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='screenLeaderTopLabel'
            value={`${fields['screenLeaderTop'] ?? ''}`}
          />
        </FormField>
        <FormField isSkeleton={isLoading} label='Sump bottom (m)' labelId='sumpBottomLabel'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='sumpBottomLabel' value={`${fields['sumpBottom'] ?? ''}`} />
        </FormField>
      </FormFieldRow>

      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Screen inside diameter (mm)' labelId='screenInsideDiameterLabel'>
          <ReadOnlyField
            isSkeleton={isLoading}
            labelledBy='screenInsideDiameterLabel'
            value={`${fields['screenInsideDiameter'] ?? ''}`}
          />
        </FormField>
        <FormField isSkeleton={isLoading} label='Slot size (mm)' labelId='slotSizeLabel'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='slotSizeLabel' value={`${fields['slotSize'] ?? ''}`} />
        </FormField>
      </FormFieldRow>
      <FormFieldRow>
        <FormField isSkeleton={isLoading} label='Slot length (mm)' labelId='slotLengthLabel'>
          <ReadOnlyField isSkeleton={isLoading} labelledBy='slotLengthLabel' value={`${fields['slotLength'] ?? ''}`} />
        </FormField>
      </FormFieldRow>
    </Card>
  )
}
